<template>
  <div class="screenCard">
    <div class="screenCard-title">
      <p>{{ $t(title) }}</p>
    </div>
    <div class="screenCard-slot" :style="slotStyleCSS">
      <slot name="container" />
    </div>
  </div>
</template>
<script>
export default {
  name: "ScreenCard",
  props: {
    title: {
      type: String,
      default: "common.unknowTitle",
    },
    isColumn: {
      type: Boolean,
      default: false,
    },
    justifyContent: {
      type: String,
      default: "flex-start",
    },
    alignItems: {
      type: String,
      default: "flex-start",
    },
  },
  computed: {
    slotStyleCSS() {
      return (
        (this.isColumn ? "flex-direction: column;" : "flex-direction: row;") +
        `justify-content: ${this.justifyContent};align-items: ${this.alignItems};`
      );
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>